import React from 'react';

export default function Carousel(props) {
  const { children, isReady, itemSelector, numberOfItems, containerClassName } =
    props;
  const [containerWidth, setContainerWidth] = React.useState();
  const [itemWidth, setItemWidth] = React.useState();
  const [scrollPosition, setScrollPosition] = React.useState();
  const [showLeft, setShowLeft] = React.useState(false);
  const [showRight, setShowRight] = React.useState(false);
  const containerRef = React.useRef(null);
  const [viewportSize, setViewportSize] = React.useState(0);
  React.useEffect(() => {
    if (!isReady) {
      return;
    }

    (function updateViewportWidth() {
      const viewport = document.querySelector('body');
      if (viewport) {
        setViewportSize(viewport.offsetWidth);
        const resizeItemObserver = new ResizeObserver((entries) => {
          const [entry] = entries;
          if (entry) {
            setViewportSize(entry.target.offsetWidth);
          }
        });

        resizeItemObserver.observe(viewport);
      }
    })();
    (function updateItemWidth() {
      const firstItem = document.querySelector(itemSelector);
      if (firstItem) {
        setItemWidth(firstItem.offsetWidth);
        const resizeItemObserver = new ResizeObserver((entries) => {
          const [entry] = entries;
          if (entry) {
            setItemWidth(entry.target.offsetWidth);
          }
        });

        resizeItemObserver.observe(firstItem);
      }
    })();

    (function updateContainer() {
      const container = containerRef.current;
      if (container) {
        setScrollPosition(container.scrollLeft);
        container.addEventListener('scroll', (e) => {
          setScrollPosition(e.currentTarget.scrollLeft);
        });
        setContainerWidth(container.scrollWidth - container.offsetWidth);
        const resizeItemObserver = new ResizeObserver((entries) => {
          const [entry] = entries;
          if (entry) {
            setContainerWidth(
              entry.target.scrollWidth - entry.target.offsetWidth
            );
          }
        });

        resizeItemObserver.observe(container);
      }
    })();
  }, [isReady]);

  React.useEffect(() => {
    if (itemWidth && containerWidth && numberOfItems) {
      const hasScrollBar = itemWidth * numberOfItems > containerWidth;
      setShowLeft(hasScrollBar && scrollPosition > 0);
      setShowRight(hasScrollBar && scrollPosition < containerWidth - 2);
    } else {
      setShowLeft(false);
      setShowRight(false);
    }
  }, [itemWidth, containerWidth, numberOfItems, scrollPosition]);

  const gradientPercentage = (() => {
    if (viewportSize < 400) {
      return 10;
    }

    return 20;
  })();

  const gradientPadding = (() => {
    if (viewportSize < 400) {
      return 25;
    }

    return 50;
  })();

  const buttonStyle = {
    cursor: 'auto',
    border: 'none',
    height: '97%',
    position: 'absolute',
    zIndex: 10,
    top: 0,
    margin: 0,
    marginTop: 5,
    marginBottom: 5,
    padding: `5px ${gradientPadding}px`,
    color: 'white',
    fontSize: '34px',
    textShadow: '#555 1px 0 10px',
  };

  return (
    <div style={{ position: 'relative' }}>
      {showLeft ? (
        <div
          className="carousel__left-button"
          style={{
            ...buttonStyle,
            left: '-11px', // because of safari
            background: `linear-gradient(90deg, rgba(from var(--primary-color) r g b / 1) ${gradientPercentage}%, rgba(from var(--primary-color) r g b / 0) 100%)`,
          }}
        />
      ) : null}
      <div ref={containerRef} className={containerClassName}>
        {children}
      </div>
      {showRight ? (
        <div
          className="carousel__right-button"
          style={{
            ...buttonStyle,
            right: 0,
            background: `linear-gradient(-90deg, rgba(from var(--primary-color) r g b / 1) ${gradientPercentage}%, rgba(from var(--primary-color) r g b / 0) 100%)`,
          }}
        />
      ) : null}
    </div>
  );
}
